import React from 'react'

const OptionFooter = () => {
  return (
    <footer className="footer">
        <div className="container">
            <div className="footer__inner">
                <a href="https://www.iprshealth.com/about-us/gdpr/patientprivacynotice/" title="Privacy Policy">Privacy & Cookies</a>
                <p>&copy; 2025 IPRS Health Limited, Speed Medical House, Matrix Park, Chorley, Lancashire, PR7 7NA.</p>
            </div>
        </div>
    </footer>
  )
}

export default OptionFooter